const state = {
  area: {}
};

const getters = {
  area: state => {
    return state.area
  }
};

const actions = {
  setArea(context, val) {
    context.commit('setArea', val);
  }
};

const mutations = {
  setArea(state, val) {
    state.area = val
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/area.js